import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    position: "relative",
    minHeight: "calc(100vh - 300px)",
    padding: "16px !important",
    marginBottom: "16px",
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 18,
    lineHeight: "24px",
    color: "#465869",
    height: "auto !important",
  },
  summaryComparationBox: {
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    padding: "10px",
  },
  downloadButton: {
    backgroundColor: "#308CDB",
    color: "#fff",
  },
  summaryComparationLabel: {
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 500,
  },
  summaryComparationValue: {
    fontFamily: "Manrope",
    fontSize: 24,
    fontWeight: 700,
  },
  summaryComparationMessageContainer: {
    display: "flex",
    flexDirection: "row",
    paddingTop: "10px",
  },
  actionButtons: {
    position: "absolute",
    bottom: 0,
    right: "16px",
    width: "50%",
  },
  spaceToScreenshot: {
    padding: "4px 16px",
  },
  menuActionsButton: {
    position: "absolute",
    bottom: 0,
    left: "16px",
  },
}));

export default styles;
